/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'brutal',
    quality: 0.1,
    mana: -2,
    damageMod: 0.15
}